import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { AChartComponent } from "../../achart/achart.component";
import { NgbModalOptions, NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Workspace } from "../../../model/workspace.data";
import { IIndicator, IIndicatorParam, DeepCopyIndicators } from "../../achart/indicators";
import { ChartDisplayMode } from "../../../enums/ChartDisplayMode.list";
import { AppComponentBase } from "../../../services/AppComponentBase";

import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { strategyCellRendererComponent } from "../../../renderers/strategyCellRendererComponent.component";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { callNextAsync } from "../../../services/BaseService";
import { ShowSaveModal, ShowRenameStrategyModal, ShowDeleteModal, ShowAddNewStrategyModal } from "./show-saved-strategies-modal";

@Component({
    selector: "SavedStrategiesModal",
    template: require('./SavedStrategiesModal.component.html'),
    styles: [require('./SavedStrategiesModal.component.css')]
})
export class SavedStrategiesModalComponent extends AppComponentBase implements OnInit, AfterViewInit {
    addToExisting: boolean = false;

    selectedOption: string = "test2";

    @ViewChild("StrategyNameNew")
    StrategyNameNew!: ElementRef;

    achart: AChartComponent[] = [];

    get userStrategies() {
        return Object.keys(this.workspace.userIndicators) || [];
    }

    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        protected globalGridModeService: GlobalGridModeService,
        protected ngbModalService: NgbModal
    ) {
        super(injector);

        /*********GRID */

        this.gridOptions = <GridOptions>{};
        this.gridOptions.defaultColDef = {
            cellClass: "orders-cell"
            // width:150,
        };

        this.gridOptions.enableFilter = true;
        this.rowSelection = "single";

        this.globalGridModeService.sendModelChange.subscribe(v => {
            console.log("SAVEDNEWSTRATEGY");
            this.refreshGridData();
            this.seletedRowStrategyid = "";
        });

        /***************GRID* */
        (window as any).savedStrategiesModal = this;
    }

    ifNotEmptyGetValue(value: string | undefined, defaultValue: string) {
        return value && value.trim() != "" ? value : defaultValue;
    }

    ngOnInit() {}
    ngAfterViewInit(): void {}

    private _strategyToRename: string = "";
    public get strategyToRename(): string {
        return this._strategyToRename;
    }
    public set strategyToRename(value: string) {
        this._strategyToRename = value;
    }

    private _strategyToSave: string = "";
    public get strategyToSave(): string {
        return this._strategyToSave;
    }
    public set strategyToSave(value: string) {
        this._strategyToSave = value;
    }

    initForm(achart: AChartComponent[], type: string = "standard", Id: string = "") {
        this.achart = achart;
        this.selectedOption = "";
        this.modalSubType = type;
        this.strategyToDelete = Id;

        if (type == "renameStrategy") {
            this.strategyToRename = Id;
        }
        if (type == "saveStrategy") {
            this.strategyToSave = Id;
        }
    }

    /***NEW ITEMS */
    private _modalSubType: string = "standard";
    public get modalSubType(): string {
        return this._modalSubType;
    }
    public set modalSubType(value: string) {
        this._modalSubType = value;
    }
    private _newStrategyName: string = "";
    public get newStrategyName(): string {
        return this._newStrategyName;
    }
    public set newStrategyName(value: string) {
        this._newStrategyName = value;
    }

    getRowNodeId(data: any) {
        return data.id;
    }

    saveNewStrategy(activeModal: NgbActiveModal) {
        if (this.newStrategyName && this.newStrategyName != "") {
            let current = this.workspace.userIndicators[this.newStrategyName] || {
                chartIndicatorInstances: {},
                wizardIndicatorInstances: {},
                serieType: {}
            };
            if(current.serieType == undefined) current.serieType = {};

            current.serieType[ChartDisplayMode.CHARTING] = this.achart[0].Config.ChartingSerie;
            current.serieType[ChartDisplayMode.WIZARD] = this.achart[0].Config.WizardSerie;
            current.chartIndicatorInstances = DeepCopyIndicators([this.achart[0].indicatorInstances]);
            current.chartColors = current.chartColors || {};

            current.chartColors.AxisColor = this.achart[0].AxisColor;
            current.chartColors.BackgroundColor = this.achart[0].BackgroundColor;
            current.chartColors.CandleStickSerieBorderColor = this.achart[0].CandleStickSerieBorderColor;
            current.chartColors.CandleStickSerieFallingColor = this.achart[0].CandleStickSerieFallingColor;
            current.chartColors.CandleStickSerieRisingColor = this.achart[0].CandleStickSerieRisingColor;
            current.chartColors.FontColor = this.achart[0].FontColor;
            current.chartColors.GridColor = this.achart[0].GridColor;
            current.chartColors.LineSeriesColor = this.achart[0].LineSeriesColor;
            current.chartColors.MinorGridColor = this.achart[0].MinorGridColor;
            current.chartColors.WizardLineSeriesColor = this.achart[0].WizardLineSeriesColor;
            current.showResistanceLines = this.achart[0].showResistanceLines;

            this.workspace.userIndicators[this.newStrategyName] = current;
            this.workspace.setChangedProperty("userIndicators", true);
            this.workspace.saveUserStrategiesIndicators().then(() => {
                callNextAsync(this.globalGridModeService.sendModelChange, true).then(() => {
                    activeModal.close();
                });
            });

            //////////
        }
    }

    saveStrategy(strategyToSave: string) {
        if (strategyToSave && strategyToSave != "") {
            let current = this.workspace.userIndicators[strategyToSave] || {
                chartIndicatorInstances: {},
                wizardIndicatorInstances: {},
                serieType: {}
            };

            if(current.serieType == undefined) current.serieType = {};
            current.serieType[ChartDisplayMode.CHARTING] = this.achart[0].Config.ChartingSerie;
            current.serieType[ChartDisplayMode.WIZARD] = this.achart[0].Config.WizardSerie;
            current.chartIndicatorInstances = DeepCopyIndicators([this.achart[0].indicatorInstances]);
            current.chartColors = current.chartColors || {};

            current.chartColors.AxisColor = this.achart[0].AxisColor;
            current.chartColors.BackgroundColor = this.achart[0].BackgroundColor;
            current.chartColors.CandleStickSerieBorderColor = this.achart[0].CandleStickSerieBorderColor;
            current.chartColors.CandleStickSerieFallingColor = this.achart[0].CandleStickSerieFallingColor;
            current.chartColors.CandleStickSerieRisingColor = this.achart[0].CandleStickSerieRisingColor;
            current.chartColors.FontColor = this.achart[0].FontColor;
            current.chartColors.GridColor = this.achart[0].GridColor;
            current.chartColors.LineSeriesColor = this.achart[0].LineSeriesColor;
            current.chartColors.MinorGridColor = this.achart[0].MinorGridColor;
            current.chartColors.WizardLineSeriesColor = this.achart[0].WizardLineSeriesColor;
            current.showResistanceLines = this.achart[0].showResistanceLines;

            this.workspace.userIndicators[strategyToSave] = current;
            this.workspace.setChangedProperty("userIndicators", true);
            this.workspace.saveUserStrategiesIndicators();
        }
        this.activeModal.dismiss();
    }

    private _seletedRowStrategyid: string = "";
    public get seletedRowStrategyid(): string {
        return this._seletedRowStrategyid;
    }
    public set seletedRowStrategyid(value: string) {
        this._seletedRowStrategyid = value;
    }

    loadStrategy(strategyId: string, addToExisting: boolean) {
        let current = this.workspace.userIndicators[strategyId] || {
            chartIndicatorInstances: {}
        };

        
        if(current.serieType == undefined) current.serieType = {};
        const chartingSerieType = current.serieType[ChartDisplayMode.CHARTING];
        const wizardSerieType = current.serieType[ChartDisplayMode.WIZARD];

        if(chartingSerieType != undefined)
        {
            if(this.achart[0].Config.DisplayMode == ChartDisplayMode.CHARTING)
                this.achart[0].chartSerieType = chartingSerieType;

            this.achart[0].Config.ChartingSerie = chartingSerieType;
        }
        if(wizardSerieType != undefined)
        {
            if(this.achart[0].Config.DisplayMode == ChartDisplayMode.WIZARD)
                this.achart[0].chartSerieType = wizardSerieType;
                
            this.achart[0].Config.WizardSerie = wizardSerieType;
        }
        this.achart[0].hideIndicators(this.achart[0].indicatorInstances)
        //.then(() => {
            if (this.achart[0].Config.DisplayMode == ChartDisplayMode.CHARTING) {
                this.achart[0].Config.chartIndicatorInstances = DeepCopyIndicators(
                    addToExisting
                        ? [this.achart[0].indicatorInstances, current.chartIndicatorInstances]
                        : [current.chartIndicatorInstances]
                );
            }
            if (this.achart[0].Config.DisplayMode == ChartDisplayMode.WIZARD) {
                this.achart[0].Config.wizardIndicatorInstances = DeepCopyIndicators(
                    addToExisting
                        ? [this.achart[0].indicatorInstances, current.chartIndicatorInstances]
                        : [current.chartIndicatorInstances]
                );
            }

            this.achart[0].showIndicators(this.achart[0].indicatorInstances);
            current.chartColors = current.chartColors || {};
            this.achart[0].AxisColor = this.ifNotEmptyGetValue(current.chartColors.AxisColor, this.achart[0].AxisColor);
            this.achart[0].BackgroundColor = this.ifNotEmptyGetValue(
                current.chartColors.BackgroundColor,
                this.achart[0].BackgroundColor
            );
            this.achart[0].CandleStickSerieBorderColor = this.ifNotEmptyGetValue(
                current.chartColors.CandleStickSerieBorderColor,
                this.achart[0].CandleStickSerieBorderColor
            );
            this.achart[0].CandleStickSerieFallingColor = this.ifNotEmptyGetValue(
                current.chartColors.CandleStickSerieFallingColor,
                this.achart[0].CandleStickSerieFallingColor
            );
            this.achart[0].CandleStickSerieRisingColor = this.ifNotEmptyGetValue(
                current.chartColors.CandleStickSerieRisingColor,
                this.achart[0].CandleStickSerieRisingColor
            );
            this.achart[0].FontColor = this.ifNotEmptyGetValue(current.chartColors.FontColor, this.achart[0].FontColor);
            this.achart[0].GridColor = this.ifNotEmptyGetValue(current.chartColors.GridColor, this.achart[0].GridColor);
            this.achart[0].LineSeriesColor = this.ifNotEmptyGetValue(
                current.chartColors.LineSeriesColor,
                this.achart[0].LineSeriesColor
            );
            this.achart[0].MinorGridColor = this.ifNotEmptyGetValue(
                current.chartColors.MinorGridColor,
                this.achart[0].MinorGridColor
            );
            this.achart[0].WizardLineSeriesColor = this.ifNotEmptyGetValue(
                current.chartColors.WizardLineSeriesColor,
                this.achart[0].WizardLineSeriesColor
            );

            this.achart[0].showResistanceLines =
                current.showResistanceLines != undefined ? current.showResistanceLines : false;

            if (this.achart[0].Config.DisplayMode == ChartDisplayMode.WIZARD) {
                this.achart[0].drawWizard();
            } else if (this.achart[0].Config.DisplayMode == ChartDisplayMode.CHARTING) {
                this.achart[0].drawCharting();
            } else if (this.achart[0].Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                this.achart[0].drawEntrySignals();
            }

            this.activeModal.close();
      //  });
    }

    private _strategyToDelete: string = "";
    public get strategyToDelete(): string {
        return this._strategyToDelete;
    }
    public set strategyToDelete(value: string) {
        this._strategyToDelete = value;
    }

    deleteSelelectedStrategy(strategyId: string) {
        if (strategyId != "") {
            delete this.workspace.userIndicators[strategyId];
            this.workspace.setChangedProperty("userIndicators", true);
            this.workspace.saveUserStrategiesIndicators().then(() => {
                callNextAsync(this.globalGridModeService.sendModelChange, true).then(() => {
                    this.activeModal.close();
                });
            });
        } else {
            callNextAsync(this.globalGridModeService.sendModelChange, true).then(() => {
                this.activeModal.close();
            });
        }
    }

    renameStrategy(strategyToRename: string) {
        let newItem = this.renameObjectKey(this.workspace.userIndicators, strategyToRename, this.newStrategyName);
        this.workspace.userIndicators = newItem;
        this.workspace.setChangedProperty("userIndicators", true);
        this.workspace.saveUserStrategiesIndicators();

        callNextAsync(this.globalGridModeService.sendModelChange, true);

        this.activeModal.close();
    }

    renameObjectKey(oldObj: any, oldName: any, newName: any) {
        const newObj: any = {};

        Object.keys(oldObj).forEach(key => {
            const value = oldObj[key];

            if (key === oldName) {
                newObj[newName] = value;
                return newObj;
            } else {
                newObj[key] = value;
            }
        });
        return newObj;
    }

    /*****************************GRID */

    columnDefs = [
        {
            headerName: "Name",
            field: "name",
            width: 265,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
        {
            headerName: " ",
            width: 50,
            cellStyle: { "text-align": "left", "padding-left": "5px !important;" },
            cellRendererFramework: strategyCellRendererComponent,
            cellRendererParams: {
                edit: this.editAction.bind(this),
                delete: this.deleteAction.bind(this),
                modalService: this.ngbModalService,
                chart: this.achart
            }
        }
    ];

    public gridOptions: GridOptions;
    public rowSelection: any;
    protected gridApi: any;
    protected gridColumnApi: any;

    editAction(params: any) {
        ShowRenameStrategyModal(params.chart, params.modalService, params.data.name, this.workspace.mobileMode);
    }

    deleteAction(params: any) {
        ShowDeleteModal(params.chart, params.modalService, params.data.name, this.workspace.mobileMode);
    }

    public onGridReady(params: GridOptions) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        if (this.gridApi) this.gridApi.setRowData([]);

        if (this.columnDefs[1].cellRendererParams) {
            this.columnDefs[1].cellRendererParams.chart = this.achart;
        }

        this.refreshGridData();
    }

    refreshGridData() {
        if (this.gridApi) {
            this.gridApi.setRowData([]);
            let newItems = this.userStrategies.map(function(item) {
                return { name: item };
            });
            this.gridApi.updateRowData({ add: newItems });
            this.gridApi.clearFocusedCell();
        }
    }

    public onSelectionChanged(e: any) {
        if (this.gridApi !== undefined) {
            let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);

            if (row !== undefined) {
                this.seletedRowStrategyid = row.data.name;
            }
        }
    }

    /*****************END GRID**************** */

    showAddNewStrategywindow(event: any) {
        event.stopPropagation();
        ShowAddNewStrategyModal(this.achart, this.modalService, this.workspace.mobileMode);
    }

    showSaveStrategywindow(event: any, id: string) {
        event.stopPropagation();
        ShowSaveModal(this.achart, this.modalService, id, this.workspace.mobileMode);
    }
}